import React from 'react';

/** Page-local to the SEO page (no claim needed): `value`, once it has stayed the same for `ms` (the first render returns it at once). */
export const useDebouncedValue = <T>(value: T, ms: number): T => {
  const [debounced, setDebounced] = React.useState(value);
  React.useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), ms);
    return () => window.clearTimeout(timer);
  }, [value, ms]);
  return debounced;
};

export default useDebouncedValue;
